import tick from '../assets/icon/tick1.png'

const orderStatus = ["Received", "Confirmed", "Processing", "In Transit", "Order Delivered"]

function Order_status({status}) {
    return ( 
    <div className="order_status">
        
        { status <4 && <>
        
        <div className="o-s-line1 verti_center"></div>
        <div className="o-s-line verti_center"
            style={{width:`calc(${status*25 + 10}%)` }}
        ></div>
        

        <div className="o-s">
            
            <div className="o-s-circle">
            {orderStatus.map((val, key)=>{
                return(
                <div className={key===0 ? "o-s-single" : "o-s-single-margin"} >
                    <div className={key <= status ? "o-s-round-c o-s-done" : "o-s-round"}>
                        {key <= status &&
                            <img src={tick} style={{width:"100%", height:"100%", objectFit:"contain", position:"absolute"}}/>
                        }
                    </div>
                </div>) 
            })}
            </div>

        </div>
        <div>

        </div>
        </>}
    </div> );
}

export default Order_status;